module.exports = __webpack_public_path__ + "static/media/rudra.f2369016.jpg";